export enum Transform {
  Uppercase = 'uppercase',
  Capitalize = 'capitalize',
  None = 'none',
}
